"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var background = function (color) { return "background: " + color + ";"; };
exports.default = (function (_a) {
    var checked = _a.checked, disabled = _a.disabled;
    return function (_a) {
        var theme = _a.theme;
        if (checked && disabled) {
            return background(theme.palette.inputCheckBoxBgChecked[1]);
        }
        return checked && !disabled
            ? background(theme.palette.inputCheckBoxBgChecked[0]) : background(theme.palette.inputCheckBoxBg);
    };
});
